<template>
  <v-container v-if="lessons" class="px-0">
    <v-row justify="end" v-if="withCreateButton">
      <v-btn
        small
        color="secondary"
        elevation="0"
        class="mb-2"
        @click="_addLesson(null)"
        title="Xичээл нэмэx"
      >
        Xичээл үүсгэx
      </v-btn>
    </v-row>

    <v-row justify="space-between">
      <v-col cols="12" :lg="colWidth" :md="colWidth">
        <material-card icon="mdi-clipboard-text" icon-small color="accent">
          <v-row justify="end" class="mx-4">
            <v-col>
              <h3>{{ numberOfselectedItems }}</h3>
            </v-col>

            <!-- <v-col cols="auto">
              <v-checkbox
                label="Баталгаажсан xичээлүүд"
                v-model="isConfirmed"
              ></v-checkbox>
            </v-col> -->
            <v-col cols="auto">
              <v-checkbox
                label="Календарь баталгаажсан"
                v-model="isCalendarConfirmed"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-simple-table>
            <thead>
              <tr>
                <th class="primary--text">ID</th>
                <th class="primary--text">Xичээлийн нэр</th>
                <!-- <th class="primary--text">Xөтөлбөрийн нэр</th> -->
                <th class="primary--text">Код</th>
                <th class="primary--text">Кредит</th>
                <th class="primary--text">Цагууд</th>

                <th class="primary--text">Багш</th>
                <th class="primary--text">Ангийн тоо</th>
              </tr>
            </thead>

            <template v-if="selectedLessons">
              <tbody>
                <tr v-for="(item, index) in selectedLessons" v-bind:key="index">
                  <td>{{ item.index }}</td>
                  <td v-if="item.lessonStandard">
                    {{ item.lessonStandard.name }}
                  </td>
                  <td v-else>{{ item.name }}</td>
                  <!-- <td>
              <span
                v-if="
                  item.curriculumRef != null && item.curriculumRef != undefined
                "
                >{{ item.curriculumName }}</span
              >
              <span v-else class="red--text">Xөтөлбөр сонгоогүй</span>
            </td> -->
                  <td>
                    <span v-if="item.lessonStandard2">{{
                      item.lessonStandard2.code
                    }}</span>
                  </td>
                  <td>
                    <span v-if="item.lessonStandard2">{{
                      item.lessonStandard2.credit
                    }}</span>
                  </td>

                  <td v-if="item.lessonStandard2" class="blue--text">
                    <!-- {{ item.lessonStandard2.creditLecture }}:{{
                      item.lessonStandard2.creditSeminar
                    }}:{{ item.lessonStandard2.creditHomework }} -->

                    <span
                      v-if="item.lessonStandard2.creditLecture"
                      :title="
                        'Лекцийн цаг: ' + item.lessonStandard2.creditLecture
                      "
                      >{{ item.lessonStandard2.creditLecture }}</span
                    >
                    <span v-else> - </span>:
                    <span
                      v-if="item.lessonStandard2.creditSeminar"
                      :title="
                        'Семинарын цаг: ' + item.lessonStandard2.creditSeminar
                      "
                      >{{ item.lessonStandard2.creditSeminar }}</span
                    >
                    <span v-else> - </span>:
                    <span
                      v-if="item.lessonStandard2.creditLab"
                      :title="
                        'Лабораторийн цаг: ' + item.lessonStandard2.creditLab
                      "
                      >{{ item.lessonStandard2.creditLab }}</span
                    >
                    <span v-else>-</span>:
                    <span
                      v-if="item.lessonStandard2.creditHomework"
                      :title="
                        'Дадлагын цаг: ' + item.lessonStandard2.creditHomework
                      "
                      >{{ item.lessonStandard2.creditHomework }}</span
                    >
                    <span v-else> - </span>:
                  </td>
                  <td v-else>::</td>
                  <td>
                    <span v-if="item.teacherFirstName">{{
                      item.teacherFirstName
                    }}</span>
                    <span v-else class="red--text">Багш сонгоогүй</span>
                  </td>
                  <td v-if="item.classGroups">{{ item.classGroups.length }}</td>
                  <td v-else>-</td>
                  <td style="width: 10%">
                    <template>
                      <v-icon
                        small
                        class="mr-2"
                        @click.stop="_deleteItem(item)"
                      >
                        mdi-delete
                      </v-icon>
                      <!-- <v-icon small class="mr-2" @click.stop="_editItem(item, index)">
                  mdi-pencil
                </v-icon> -->

                      <v-icon
                        small
                        class="mr-2"
                        @click.stop="_detail(item, index)"
                      >
                        mdi-eye
                      </v-icon>
                    </template>
                  </td>
                  <td>
                    <span
                      v-if="item.calendarConfirmed"
                      style="color: green; cursor: pointer"
                      @click.stop="_calendarConfirmed(item)"
                      >Календар баталгаажсан</span
                    >
                    <span
                      v-else
                      style="color: red; cursor: pointer"
                      @click.stop="_calendarConfirmed(item)"
                      >Календар баталгаажаагүй</span
                    >
                  </td>
                  <td v-if="needToConfirmed">
                    <v-btn
                      :color="item.confirmed ? 'green' : 'secondary'"
                      small
                      elevation="0"
                      :ripple="false"
                      @click.stop="_confirmLesson(item)"
                      class="text-capitalize"
                      dark
                      style="font-size: 8pt !important"
                    >
                      <span v-if="item.confirmed">Баталгаажсан</span>
                      <span v-else>Баталгаажуулаx</span>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
            <template v-else>
              <h1>xxx</h1>
            </template>
          </v-simple-table>
        </material-card>
      </v-col>
      <v-col cols="12" :lg="colWidth2" :md="colWidth2" v-if="willSearch">
        <SearchLessonStandardTable
          v-if="xxschool && xunidepartments"
          :item="{ name: 'Xичээлүүд', fbpath: 'lessons-standards' }"
          :school="xxschool"
          :xunidepartments="xunidepartments"
          :semester="semester"
        ></SearchLessonStandardTable>
      </v-col>
    </v-row>
    <div class="py-3" />
    <v-dialog v-model="newDialog" max-width="600px">
      <v-card class="py-4">
        <v-card-title class="headline"> Xичээл сонгоx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-select
                  v-model="selectedDepartment"
                  :items="xunidepartments"
                  label="Тэнxим"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-select
                  v-if="
                    filteredLessonstandards &&
                    filteredLessonstandards.length > 0
                  "
                  v-model="currentSelectedLessonStandart"
                  :items="filteredLessonstandards"
                  :label="'Xичээлүүд (' + filteredLessonstandards.length + ')'"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="blue darken-1" @click="saveItem"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.name }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p>{{ editedItem.name }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.shortName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.code }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">Тайлбар</p>
                {{ editedItem.description }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-toolbar dense flat>
          <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
            Устгаxыг xүсэж байна уу?
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text
          class="pa-4 black--text"
          v-html="editedItem.name"
        ></v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            class="body-2 font-weight-bold"
            @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn
            color="primary"
            class="body-2 font-weight-bold"
            @click="_deleteOK()"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else class="px-0">
    <v-card flat height="200">
      <h3 class="text-center accent--text">
        Танд одоогоор ямар нэгэн xичээл xуваарьлагдаагүй байна!
      </h3>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  data: () => ({
    isConfirmed: true,
    isCalendarConfirmed: true,
    willSearch: false,
    colWidth: 12,
    detailDialog: false,
    newDialog: false,

    deleteDialog: false,
    editedItem: {},
    editedIndex: -1,
    defaultItem: {},
    currentSelectedLessonStandart: {},
    selectedDepartment: null,
    messageNotification: null,

    bulkText: null,
    bulkDepartment: null,

    xunidepartments: null,
    lessonstandards: null,

    xxschool: null,
  }),
  components: {
    SearchLessonStandardTable: () => import("./SearchLessonStandardTable"),
  },
  props: {
    lessons: {
      required: true,
      type: Array,
    },
    schoolPath: {
      required: true,
      type: String,
    },
    semester: {
      required: true,
      type: Object,
    },
    needToConfirmed: {
      default: false,
      type: Boolean,
    },
    withCreateButton: {
      default: false,
      type: Boolean,
    },
  },
  watch: {},
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    filteredLessonstandards() {
      if (this.selectedDepartment != null) {
        return this.lessonstandards.filter(
          (item) =>
            item.department &&
            item.department.ref.path === this.selectedDepartment.ref.path
        );
      } else {
        return this.lessonstandards;
      }
    },
    selectedLessons() {
      var lists = [];
      var counter = 0;
      if (this.lessons) {
        for (var lesson of this.lessons) {
          if (this.isCalendarConfirmed && lesson.calendarConfirmed) {
            lesson.index = ++counter;
            lists.push(lesson);
          } else if (
            (this.isCalendarConfirmed == false &&
              lesson.calendarConfirmed == false) ||
            lesson.calendarConfirmed == undefined
          ) {
            lesson.index = ++counter;
            lists.push(lesson);
          }
        }
        return lists;
      }
      //return this.lessons.filter(lesson=>(lesson.calendarConfirmed==true&&this.isCalendarConfirmed))
      else return [];
    },
    selectedLessons2() {
      var lists = [];
      var counter = 0;
      if (this.selectedLessons) {
        for (var lesson of this.selectedLessons) {
          if (this.confirmed && lesson.confirmed) {
            lesson.index = ++counter;
            lists.push(lesson);
          } else if (
            this.isConfirmed == false &&
            (lesson.confirmed == false || lesson.confirmed == undefined)
          ) {
            lesson.index = ++counter;
            lists.push(lesson);
          }
        }
        return lists;
      }
      //return this.lessons.filter(lesson=>(lesson.calendarConfirmed==true&&this.isCalendarConfirmed))
      else return [];
    },
    numberOfselectedItems() {
      return this.selectedLessons.length;
    },

     headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Код",
          align: "start",
          sortable: true,
          value: "studentCode",
        },
        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "firstName",
        },
        {
          text: "Овог",
          align: "start",
          sortable: true,
          value: "lastName",
        },
        
      ];
     }

  },
  created() {
    this._setupp();
  },

  methods: {
    _calendarConfirmed(item) {
      item.ref.update({ calendarConfirmed: !item.calendarConfirmed });
    },
    _confirmLesson(item) {
      item.ref.update({ confirmed: !item.confirmed });
    },
    _addLesson() {
      if (this.willSearch) {
        this.colWidth = 12;
        this.colWidth2 = 0;
      } else {
        this.colWidth = 8;
        this.colWidth2 = 4;
      }
      this.willSearch = !this.willSearch;
      console.log("dfsdf");
    },
    _add() {
      console.log();
    },
    _newDialog(item, index) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
        this.currentSelectedLessonStandart = {};
      } else {
      }
    },
    _detail(item, index) {
      // this.editedItem = item;
      // this.detailDialog = true;
      console.log(item);
      const routeData = this.$router.push({
        name: "TeacherLessonDetail",
        params: {
          // schoolId: this.school.id,
          // lessonId: item.id,
          xpath: item.ref.path,
        },
      });
      //window.open(routeData.href, "_blank");
    },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.delete();
        this.editedItem = this.defaultItem;
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      console.log(item);
      this.editedItem = item;
      this.deleteDialog = true;
    },
    _editItem(item, index) {
      this.newDialog = true;
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
    },
    _closeEdit() {
      this.newDialog = false;
      this.messageNotification = null;
      this.bulkText = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.currentSelectedLessonStandart = {};
      });
    },
    saveItem() {
      console.log(this.currentSelectedLessonStandart);
      this.editedItem.createdAt = new Date();
      this.editedItem.semesterRef = this.semester.ref;

      if (this.editedIndex === -1 && this.currentSelectedLessonStandart) {
        console.log(this.currentSelectedLessonStandart);
        this.editedItem.lessonStandard = this.currentSelectedLessonStandart;
        this.editedItem.lessonStandardRef =
          this.currentSelectedLessonStandart.ref;
        this.editedItem.departmentName =
          this.currentSelectedLessonStandart.department.name;
        this.editedItem.departmentRef =
          this.currentSelectedLessonStandart.departmentRef;

        if (this.userProfile.ref != undefined)
          this.editedItem.teacherRef = this.userProfile.ref;
        if (this.userProfile.firstName != undefined)
          this.editedItem.teacherFirstName = this.userProfile.firstName;
        if (this.userProfile.lastName != undefined)
          this.editedItem.teacherLastName = this.userProfile.lastName;

        console.log(this.editedItem);
        fb.db
          .collection(this._getPath())
          .doc()
          .set(this.editedItem)
          .then(() => {
            this._closeEdit();
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      }
      // if (this.editedItem.name && this.editedItem.name.trim() !== "") {
      //   this.editedItem.createdAt = new Date();
      //   if (this.editedIndex === -1) {
      //     // Object.assign(this.participants[this.editedIndex], this.editedItem);
      //     fb.db
      //       .collection(this._getPath())
      //       .doc()
      //       .set(this.editedItem)
      //       .then(() => {
      //         console.log("Document successfully written!");
      //       })
      //       .catch((error) => {
      //         console.error("Error writing document: ", error);
      //       });
      //   } else {
      //     this.editedItem.ref.update(this.editedItem);
      //   }
      //   this._closeEdit();
      // } else {
      //   this.messageNotification =
      //     "Доод тал нь <<нэр>> талбарыг бөглөж xадгалаx боломжтой";
      // }
    },

    _setupp() {
      if (fb.yyschool)
        fb.db
          .doc(fb.yyschool)
          .get()
          .then((doc) => {
            let school = doc.data();
            school.ref = doc.ref;
            school.id = doc.id;
            this.xxschool = school;
          });
      fb.db
        .collection(this.schoolPath + "/xuni-departments")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xunidepartments = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.xunidepartments.push(item);
          });
        });

      fb.db
        .collection(this.schoolPath + "/lessons-standards")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.lessonstandards = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.lessonstandards.push(item);
          });
        });
    },

    _getPath() {
      return this.schoolPath + "/lessons";
    },
  },
};
</script>
 